import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../../components';

const Container = styled.div`
  // padding-top: 16px;
  color: #161d1f;

  p:nth-child(1) {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 12px;
  }

  p:nth-child(2) {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .description {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 4.5em;
  }

  .expanded {
    -webkit-line-clamp: unset;
    max-height: none;
  }

  // para los enlaces dentro del texto
  .description a {
    color: #5b36f2;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #745ef6;
    }

    &:focus-visible {
      color: #4318cd;
      outline: 1px solid #4318cd;
      border-radius: 4px;
      line-height: 20px;
    }

    &:active {
      color: #4318cd;
    }
  }

  button.seeMore {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;

    &:hover {
      color: #5b36f2;
      font-weight: 700;
    }

    &:focus-visible {
      color: #5b36f2;
      font-weight: 700;
      outline: 1px solid #5b36f2;
      border-radius: 4px;
    }

    &:active {
      color: #5b36f2;
    }
  }

  button.seeLess {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;

    &:hover {
      color: #5b36f2;
      font-weight: 700;
    }

    &:focus-visible {
      color: #5b36f2;
      font-weight: 700;
      outline: 1px solid #5b36f2;
      border-radius: 4px;
    }

    &:active {
      color: #5b36f2;
    }
  }
`;
interface DescriptionProps {
  descriptionDetails: string;
}

const Description = ({ descriptionDetails }: DescriptionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const descriptionRef = useRef<HTMLParagraphElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (descriptionRef.current) {
      setIsTruncated(
        descriptionRef.current.scrollHeight >
          descriptionRef.current.clientHeight
      );
    }
  }, [descriptionDetails]);

  const handleClick = () => {
    setIsExpanded((prev) => !prev);
    setTimeout(() => buttonRef.current?.blur(), 0);
  };

  // metodo con expresion regular para detectar enlaces
  const processText = (text: string) => {
    const linkRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    const matches = [...text.matchAll(linkRegex)];
    if (matches.length === 0) return text;

    const elements = [];
    let lastIndex = 0;

    matches?.forEach((match) => {
      const startIndex = match.index || 0;
      if (startIndex > lastIndex) {
        elements.push(text.slice(lastIndex, startIndex));
      }
      const url = match[0].startsWith('www.')
        ? `https://${match[0]}`
        : match[0]; // asegura el formato correcto
      elements.push(
        <a
          key={startIndex}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {match[0]}
        </a>
      );
      lastIndex = startIndex + match[0].length;
    });
    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }
    return elements;
  };
  return (
    <Container>
      <p>Descripción</p>
      <p
        ref={descriptionRef}
        className={`description ${isExpanded ? 'expanded' : ''}`}
      >
        {processText(descriptionDetails)}
      </p>
      {isTruncated && (
        <button
          ref={buttonRef}
          type="button"
          className={isExpanded ? 'seeLess' : 'seeMore '}
          onClick={handleClick}
        >
          {isExpanded ? 'Ver menos' : 'Ver más'}
          <Icon name={isExpanded ? 'chevron-up' : 'chevron-down'} size={20} />
        </button>
      )}
    </Container>
  );
};

export default Description;
